// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "fc14b4d1b4fdf69931dfbe031094a225b637d5fd/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};